import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { metaDataSelector, setMetaData } from 'features/superBatchManagement';
import Field from 'components/Field';
import styles from './SuperBatchUpdateMetaPage.module.scss';
import Select from 'components/Select';

const RIBBON_TYPES = [{ label: 'Danger', value: 'danger' }];
function RibbonInputs() {
  const dispatch = useDispatch();
  const metaData = useSelector(metaDataSelector);

  const handleRibbonDataChange = useCallback(
    (key, event) => {
      dispatch(
        setMetaData({
          ...metaData,
          [key]: event.target.value,
        })
      );
    },
    [dispatch, metaData]
  );

  const handleTypeChange = useCallback(
    (option) => {
      dispatch(
        setMetaData({
          ...metaData,
          type: option.value,
          variant: option,
        })
      );
    },
    [dispatch, metaData]
  );

  useEffect(() => () => dispatch(setMetaData({})), [dispatch]);

  return (
    <>
      <Field
        label="Enter ribbon name."
        className={styles.select}
      >
        <input
          className={styles.ribbonAction}
          placeholder="Name will be used for tracking"
          onChange={(event) => handleRibbonDataChange('name', event)}
          value={metaData.name}
        />
      </Field>
      <Field
        label="Enter ribbon content."
        className={styles.select}
      >
        <textarea
          className={styles.ribbonText}
          onChange={(event) => handleRibbonDataChange('text', event)}
          value={metaData.text}
        />
      </Field>
      <Field
        label="Enter Action Label."
        className={styles.select}
      >
        <input
          placeholder="optional"
          className={styles.ribbonAction}
          onChange={(event) => handleRibbonDataChange('action_text', event)}
          value={metaData.action_text}
        />
      </Field>
      <Field
        label="Enter action link."
        className={styles.select}
      >
        <input
          placeholder="optional"
          className={styles.ribbonAction}
          onChange={(event) => handleRibbonDataChange('action_link', event)}
          value={metaData.action_link}
        />
      </Field>
      <Field
        label="Enter ribbon variant"
        className={styles.select}
      >
        <Select
          className={styles.ribbonType}
          placeholder="Enter ribbon type"
          value={metaData.variant}
          options={RIBBON_TYPES}
          onChange={handleTypeChange}
        />
      </Field>
    </>
  );
}

export default RibbonInputs;
